import { useAuth } from "@/lib/auth";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import api from "@/lib/api";
import { toast } from "sonner";
import { useState } from "react";

export default function Settings() {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);

  if (!user) return null;

  const openPortal = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/billing/portal", { origin_url: window.location.origin });
      window.location.href = data.url;
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Erreur portail");
      setLoading(false);
    }
  };

  const statusBadge = () => {
    if (user.subscription_status === "active") return <Badge className="bg-emerald-100 text-emerald-700 hover:bg-emerald-100">Pro · Actif</Badge>;
    if (user.subscription_status === "past_due") return <Badge className="bg-red-100 text-red-700 hover:bg-red-100">Paiement échoué</Badge>;
    if (user.subscription_status === "inactive") return <Badge className="bg-slate-200 text-slate-700 hover:bg-slate-200">Inactif</Badge>;
    return <Badge className="bg-amber-100 text-amber-700 hover:bg-amber-100">Essai gratuit</Badge>;
  };

  return (
    <div className="p-8 lg:p-10 max-w-3xl">
      <div className="mb-10">
        <div className="text-xs tracking-[0.3em] uppercase text-slate-500 mb-2">Réglages</div>
        <h1 className="font-display text-4xl tracking-tight">Votre compte</h1>
      </div>

      <div className="border border-slate-200 bg-white">
        <div className="p-6 border-b border-slate-100">
          <div className="text-xs uppercase tracking-wider text-slate-500">Nom</div>
          <div className="font-medium mt-1">{user.name}</div>
        </div>
        <div className="p-6 border-b border-slate-100">
          <div className="text-xs uppercase tracking-wider text-slate-500">Email</div>
          <div className="font-medium mt-1 font-mono text-sm">{user.email}</div>
        </div>
        <div className="p-6 border-b border-slate-100">
          <div className="text-xs uppercase tracking-wider text-slate-500">Entreprise</div>
          <div className="font-medium mt-1">{user.company || "—"}</div>
        </div>
        <div className="p-6 flex items-center justify-between flex-wrap gap-4">
          <div>
            <div className="text-xs uppercase tracking-wider text-slate-500">Abonnement</div>
            <div className="font-medium mt-1 flex items-center gap-2">{statusBadge()}</div>
            {user.subscription_end && <div className="text-xs text-slate-500 mt-1">Prochaine échéance : {new Date(user.subscription_end).toLocaleDateString()}</div>}
          </div>
          <div className="flex items-center gap-3">
            {(user.subscription_status === "active" || user.subscription_status === "past_due") && user.stripe_customer_id && (
              <Button onClick={openPortal} disabled={loading} variant="outline" className="btn-pill" data-testid="settings-portal-btn">
                {loading ? "Ouverture…" : "Gérer mon abonnement"}
              </Button>
            )}
            {user.subscription_status !== "active" && (
              <Link to="/pricing"><Button className="bg-[#2563EB] hover:bg-[#1D4ED8] btn-pill" data-testid="settings-upgrade-btn">Passer Pro · $50/mois</Button></Link>
            )}
          </div>
        </div>
      </div>

      <div className="mt-6 text-xs text-slate-500">
        Le paiement et la facturation sont gérés en toute sécurité par Stripe. Vous pouvez annuler à tout moment depuis le portail.
      </div>
    </div>
  );
}
